import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { projectApi, errText, cents } from "../../lib/projectAccess";

function Row({ label, value, testid }) {
  return (
    <div className="flex justify-between gap-3 py-2 border-b border-erf-borderCream last:border-0">
      <dt className="text-xs text-erf-dark/70">{label}</dt>
      <dd className="font-mono text-sm text-erf-dark text-right" data-testid={testid}>{value ?? "Not recorded"}</dd>
    </div>
  );
}

// Decision 3: read-only, own subcontract only. Payments are shown as not tracked (never invented).
export default function MySubcontract() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { projectApi.mySubcontract(id).then((r) => setD(r.data)).catch((e) => setErr(errText(e))); }, [id]);

  return (
    <AppShell title="My subcontract" subtitle="Read-only · your company's records on this project">
      <div className="mx-auto w-full max-w-[760px] px-4 md:px-6 space-y-4" data-testid="my-subcontract-page">
        <Link to="/my/projects" className="inline-flex items-center min-h-[44px] text-xs font-nav underline" data-testid="my-subcontract-back">
          Back to My Projects
        </Link>
        {err && <div className="text-sm text-red-700" role="alert" data-testid="my-subcontract-error">{err}</div>}
        {!d && !err && <div className="font-mono text-xs text-erf-dark/60" data-testid="my-subcontract-loading">Loading…</div>}
        {d?.status === "not_linked" && <p className="text-sm" data-testid="my-subcontract-not-linked">{d.message}</p>}
        {d?.status === "linked" && (
          <>
            <section className="bg-white border border-erf-borderCream rounded-md p-4" aria-labelledby="sub-summary">
              <h2 id="sub-summary" className="font-nav text-sm font-semibold mb-2" data-testid="my-subcontract-company">{d.company}</h2>
              <dl>
                <Row label="Approved value" value={cents(d.approved_value_cents)} testid="my-subcontract-value" />
                <Row label="Approved change orders" value={cents(d.approved_change_orders_cents)} testid="my-subcontract-cos" />
                <Row label="Invoiced" value={cents(d.invoiced_cents)} testid="my-subcontract-invoiced" />
                <Row label="Payments" value="Not tracked" testid="my-subcontract-payments" />
                <Row label="Outstanding (value + approved COs)" value={cents(d.outstanding_cents)} testid="my-subcontract-outstanding" />
              </dl>
              <p className="mt-2 text-[11px] text-erf-dark/60" data-testid="my-subcontract-payments-note">{d.payments_note}</p>
            </section>
            <section className="bg-white border border-erf-borderCream rounded-md p-4" aria-labelledby="sub-invoices">
              <h2 id="sub-invoices" className="font-nav text-sm font-semibold mb-2">Your invoices</h2>
              {d.invoices.length === 0 ? <p className="text-xs text-erf-dark/70" data-testid="my-subcontract-no-invoices">None submitted yet.</p> : (
                <ul className="divide-y divide-erf-borderCream" data-testid="my-subcontract-invoices">
                  {d.invoices.map((b) => (
                    <li key={b.bill_number} className="flex justify-between py-2 text-sm">
                      <span className="font-mono">{b.bill_number} · {b.state}</span><span className="font-mono">{cents(b.total_cents)}</span>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          </>
        )}
      </div>
    </AppShell>
  );
}
